export default () => ({
    padding: '2rem',
});
